<template>
  <div id="scroll-threshold-example">
    <div>
      <div class="mt-5" v-if="settings&&settings.options">
        <v-row :class="$vuetify.breakpoint.smAndDown?'':'mx-1'">
          <v-col cols="12">
            <v-container style="max-width:900px">
                <v-row class="px-3">
                  <v-col cols="12" md="12">
                    <div class="text-center">
                      <v-card
                        class="neu-glow py-5"        
                      >
                        <v-img v-if="!$vuetify.theme.dark"
                          :src="'/static/users/pictures/db/'+settings.options.logoDB"
                          :lazy-src="'/static/users/pictures/db/'+settings.options.logoDB"
                          max-width="400"
                          class="mx-auto"
                        >
                        </v-img>
                        <v-img v-else
                          :src="'/static/users/pictures/db/'+settings.options.logoDBW"
                          :lazy-src="'/static/users/pictures/db/'+settings.options.logoDBW"
                          max-width="400"
                          class="mx-auto"
                        >
                        </v-img>                        
                        <div v-if="bookingId">
                          <div class="text-h6 mt-3 mb-1">{{$t(page+'.Dear')}} <span v-if="booking.firstName||booking.lastName" :class="'font-weight-bold '+settings.options.color+'--text'">{{booking.firstName?booking.firstName+ ' ' :'' + booking.lastName?booking.lastName:''}}</span></div>
                          <!--<div class="text-subtitle-1 mb-3 px-3">{{$t(page+'.Thanks for accepting our invitation to release a review about your visit')}}</div>-->
                        </div>
                      </v-card>
                    </div> 
                  </v-col>
                  <v-col cols="12" v-if="user==={}">
                    <v-card class="text-center neu-glow py-5">
                      <v-progress-circular indeterminate size="300" width="20" color="info"></v-progress-circular>
                    </v-card>
                  </v-col>
                  <template v-else>
                    <v-col cols="12" class="order-3"> 
                      <v-card  class="px-2 neu-glow">
                        <v-row>
                            <v-col class="text-h6 px-4 my-3 text-left">
                              {{$t(page+'.RATE YOUR EXPERIENCE')}}
                            </v-col>
                        </v-row>
                        <v-card class="ma-1 px-2 py-2">
                            <template v-for="(v,n,i) in review">
                              <template v-if="n!='review'">
                                <v-divider v-if="i!=0" :key="i"></v-divider>
                                <v-row :key="i" class="mt-2">
                                  <v-col cols="12" class="text-h5 d-flex align-center ml-2 py-0">{{$t(page+'.'+n)}}:</v-col>
                                  <v-col cols="9" class="pt-0">
                                      <v-rating
                                        v-model="review[n]"
                                        size="28"
                                        hover   
                                        background-color="#ffdc73"
                                        color="#FFD700"
                                        empty-icon="mdi-circle-outline"
                                        full-icon="mdi-circle"
                                        class=""                                                          
                                        ></v-rating>
                                  </v-col>
                                  <v-col  class="pt-0 text-center text-h4">
                                    <v-icon v-if="review[n]>0" x-large :color="review[n]<3?'error':review[n]<5?'warning':'success'">mdi-numeric-{{review[n]}}</v-icon>
                                  </v-col>
                                </v-row>
                              </template>
                            </template>
                        </v-card>
                        <v-row class="my-3">
                            <v-col class="text-subtitle-1 pl-4 pb-1 text-left">{{$t(page+'.Write a review')}}:</v-col>
                        </v-row>
                        <v-card class="ma-2 px-2 py-2 neu-glow-inset">
                            <v-row>
                              <v-col>
                                  <v-textarea v-model="review.review" outlined hide-details auto-grow>
                                  </v-textarea>
                              </v-col>
                            </v-row>
                        </v-card>
                        <v-row class="my-3">
                            <v-col>
                              <v-btn color="info" :loading="loading" block @click="saveReview()" :disabled="Object.values(review).includes(0)">
                                  {{$t(page+'.Send Review')}}
                              </v-btn>
                            </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </template>
                </v-row>
            </v-container>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-btn
      v-if="settings"
      v-scroll="onScroll"
      v-show="scrollToTop"
      fab
      dark
      small
      fixed
      bottom
      right
      :color="settings.options.color"
      @click="toTop"
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
    <v-bottom-navigation
      color="orange"
      absolute
      hide-on-scroll
      scroll-target="#scroll-threshold-example"
      scroll-threshold="500" 
      class="mt-3 mb-4" 
      style="position:unset"
      v-if="settings"   
    >
      <v-btn :href="settings.options.facebookURL" v-if="settings.options.facebookURL">
        <span>Facebook</span>
        <v-icon color="#3b5998">mdi-facebook</v-icon>
      </v-btn>
      <v-btn :href="settings.options.instagramURL" v-if="settings.options.instagramURL">
        <span>Instagram</span>
        <v-icon color="#C13584">mdi-instagram</v-icon>
      </v-btn>
      <v-btn :href="settings.options.youtubeURL" v-if="settings.options.youtubeURL">
        <span>YouTube</span>
        <v-icon color="#c4302b">mdi-youtube</v-icon>
      </v-btn>
      <v-btn :href="settings.options.linkedInURL" v-if="settings.options.linkedInURL">
        <span>LinkedIn</span>
        <v-icon color="#0077b5">mdi-linkedin</v-icon>
      </v-btn>      
    </v-bottom-navigation>
    <div id="scroll-threshold-example">
      &nbsp;
    </div>
    <v-dialog v-model="dialog_thanks"
      width="420"
      class="neu-glow"
      v-if="dialog_thanks"
    >
      <v-card class="neu-glow-inset">
        <v-card-title class="text-h6 font-weight-bold">
          {{$t(page+'.Thanks')}}
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_thanks = false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>           
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-subtitle-1 pa-5">
          <v-card class="pa-4  neu-glow">
            <div>
              <p>{{$t(page+'.Thanks for your feedback')}} </p>
              <!--<p>{{$t(page+'.Your opinion is very important to us since it help us every day to improve')}}</p>-->
              <!--
              <div v-if="settings.options.reviewCouponClass=='yesCoupon'||((parseFloat(totalScore/4))>=parseFloat(settings.minScore)&&settings.options.reviewCouponClass=='conditionalCoupon')">
                <p>{{$t(page+'.We will send you a Free Coupon soon')}}</p>
              </div>
              -->
              <!--
              <div v-if="settings.options.reviewCouponClass=='yesCoupon'&&((parseFloat(totalScore/4))<parseFloat(settings.minScore))">
                <p>{{$t(page+'.We will send you a Free Coupon soon')}}</p>
              </div>
              
              <div v-if="settings.options.reviewCouponClass=='yesCoupon'">
                <p>{{$t(page+'.We will send you a Free Coupon soon')}}</p>
              </div>   
              Clicca sul link, lascia la recensione e scopri il COUPON omaggio.
              -->                        
              <template v-if="(parseFloat(totalScore/4))>=parseFloat(settings.minScore)">
                <div v-if="settings.options.reviewCouponClass=='conditionalCoupon'">
                  <p>{{$t(page+'.We decided to send you a FREE COUPON')}}</p>
                </div>               
                <template v-if="settings.options.tripadvisorReviewRequestEnable=='1'&&settings.options.reviewTripadvisorURL!=''&&settings.options.googleReviewRequestEnable!='1'">
                  <!-- TA ONLY -->
                  <p>{{$t(page+'.Click on the button to share your review on Tripadvisor')}} <span v-if="settings.options.reviewCouponClass!='noCoupon'"> {{$t(page+'.and discover your FREE COUPON')}}</span></p>
                </template>
                <template v-if="settings.options.googleReviewRequestEnable=='1'&&settings.options.reviewGoogleURL!=''&&settings.options.tripadvisorReviewRequestEnable!='1'">
                  <!-- G ONLY -->
                  <p>{{$t(page+'.Click on the button to share your review on Google')}} <span v-if="settings.options.reviewCouponClass!='noCoupon'"> {{$t(page+'.and discover your FREE COUPON')}}</span></p>
                </template>                
                <template v-if="settings.options.tripadvisorReviewRequestEnable=='1'&&settings.options.reviewTripadvisorURL!=''&&settings.options.googleReviewRequestEnable=='1'&&settings.options.reviewGoogleURL!=''">
                  <!-- BOTH -->
                  <p>{{$t(page+'.Click on the button to share your review on Tripadvisor or Google')}} <span v-if="settings.options.reviewCouponClass!='noCoupon'"> {{$t(page+'.and discover your FREE COUPON')}}</span></p>
                </template>                
                <v-btn @click="clicked('ta')" v-if="settings.options.tripadvisorReviewRequestEnable=='1'&&settings.options.reviewTripadvisorURL!=''" color="#00af87" block :href="settings.options.reviewTripadvisorURL">
                  Tripadvisor
                </v-btn>
                <v-btn class="mt-2" @click="clicked('go')" v-if="settings.options.googleReviewRequestEnable=='1'&&settings.options.reviewGoogleURL!=''" color="#4285F4" block :href="settings.options.reviewGoogleURL">
                  Google
                </v-btn> 
              </template>
              <!--
              <template>
                <p class="text-center pt-5"><v-icon color="red" style="font-size:140px">mdi-heart</v-icon></p>
              </template>
              -->
              <!--
              <template v-if="payloads.prizeEnabled"> 
                <div>{{$t(page+'.We are happy to inform that we have reserved you a free coupon to be used within')}}
                  <span class="font-weight-bold text-center">
                    {{' ' + addDaysFormatted(payloads.duration)}}
                  </span>
                  <span v-if="payloads.validDoW"> {{$t(page+'.on')}} {{dows.filter(d=>payloads.validDoW.includes(d.code)).map(r=>r[settings.locale]).join(', ')}} </span>
                    {{$t(page+'.for')}}
                </div>
                <p class="text-center font-weight-bold">{{payloads.highRewardName}}</p>
                <v-img v-if="payloads.highRewardImage" 
                  :src="'/static/users/pictures/coupons/'+payloads.highRewardImage||'/static/users/pictures/coupon/default.png'"
                  :lazy-src="'/static/users/pictures/coupons/'+payloads.highRewardImage||'/static/users/pictures/coupon/default.png'"
                  max-width="200"
                  class="mx-auto"
                ></v-img>
                <p v-if="payloads.highRewardDescription" class="mt-2">{{payloads.highRewardDescription}}</p>
                <p class="mt-2">{{$t(page+'.At your arrival, remember to show the QRCode to the waiter')}}</p>
                <div class="text-center">
                  <qrcode-vue :value="payloads.qrCode" :size="150" level="L"></qrcode-vue>
                </div>
                <p class="text-center mt-2">{{$t(page+'.For your convenience, we just sent you a WhatsApp message with the QR Code')}}</p>
              </template>
              -->
            </div>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_duplicated"
      width="420"
      class="neu-glow"
      v-if="dialog_duplicated"
    >
      <v-card class="neu-glow-inset">
        <v-card-title class="text-h6 font-weight-bold">
          {{$t(page+'.Review')}}
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_duplicated = false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>           
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-subtitle-1 pa-5">
          <v-card class="pa-4  neu-glow">
            <div>
              {{$t(page+'.Review already released')}}
            </div>
            <p class="text-center pt-10"><v-icon color="red" style="font-size:140px">mdi-heart</v-icon></p>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>    
    <v-snackbar v-model="snackbar.active"
      top
      timeout="2000"
      class=""
      :color="snackbar.color"
    >
      {{snackbar.text}}
    </v-snackbar>    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import QrcodeVue from 'qrcode.vue'
export default {
   components: {
      QrcodeVue,
    },
  data() {
    return {
      page: "Review",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_thanks:false,
      dialog_leave_to_tripadvisor:false,
      dialog_connection_error:false,
      dialog_duplicated:false,
      loading:false,
      origin:null,
      date:null,//new Date().toISOString().substring(0,10),
      today:new Date().toISOString().substring(0,10),
      locale:'it',   
      snackbar:{active:false,color:'success',text:''},
      reviewSaved:false,
      uu:null,
      user:{},
      booking:{firstName:null,lastName:null},
      bookingId:null,
      totalScore:0,
      partialScore:0,
      review:{"food":0,"service":0,"value":0,"location":0,"review":null},
      settings:null,
      reviewPrizeValidUntil:null,
      QRCodeLink:null,
      payloads:null,
      hostname:null,
      dows:[
            {code:1,it:'Lunedì',en:'Mondays'},
            {code:2,it:'Martedì',en:'Tuesdays'},
            {code:3,it:'Mercoledì',en:'Wednsdays'},
            {code:4,it:'Giovedì',en:'Thursdays'},
            {code:5,it:'Venerdì',en:'Fridays'},
            {code:6,it:'Sabato',en:'Saturdays'},
            {code:7,it:'Domenica',en:'Sundays'}
           ],      
    };
  },
  created(){
    this.$vuetify.theme.dark=true;
    //localStorage.removeItem('uu');
    sessionStorage.removeItem('jwt');
    const la=window.navigator.userLanguage||window.navigator.language;
    this.$store.dispatch("setLocale",la.substring(0,2));
    //console.log(813,this.uu)
    this.bookingId=this.$route.query.p;
    console.log(818,this.$route,this.$route.query,this.$route.query.bookingid);
    //console.log(819,window.location.href);
    this.origin=this.$route.path;
    console.log(347,this.origin);
    this.review.review=''
    this.Authenticate(this.bookingId)
  },  
  mounted: function () {

  },
  computed : {
    ...mapGetters(["settings","countries"]),
  },
  watch : {
  },
  methods:
  {
    addDaysFormatted(days) {
      var result = new Date();
      result.setDate(result.getDate() + days);
      return result.toLocaleDateString( this.settings.locale,{ weekday: 'long',  month: 'long', day: 'numeric' });
    },        
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.scrollToTop = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    async Authenticate(bookingId){
      this.loading=true;
      //try{
          const payload=JSON.stringify({"action":"AuthenticateReview","payload":{"bookingId":bookingId}});
          const res = await this.$http.post('/review/review.php', payload );
          console.log(1026,res);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              sessionStorage.setItem('settings', JSON.stringify(res.data.payloads.settings));
              console.log(966,document.link)
              
              //document.querySelector("link[rel*='icon']").href = this.settings.favicon?'/favicons/'+this.settings.favicon:"/favicon.ico";
              this.$store.dispatch("setSettings",res.data.payloads);
              this.settings=res.data.payloads;
              document.title = this.settings.brand + ' | Review';  
              this.booking.firstName=this.settings.firstName;
              this.booking.lastName=this.settings.lastName;
              this.booking.brand=this.settings.brand;
              this.settings.avatar=this.settings.avatar;
              this.$store.dispatch("setAvatar",this.settings.avatar);

              //console.log(918,this.user);
              
            break;
            case '0001':

            break
            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          this.loading= false;
      /*} catch(e)
      {
          this.dialog_connection_error=true;
          console.error(1215,e);
      }*/
    },
    async clicked(channel)
    {
      var review= {... this.review}
      review.channel=channel;
      review.bookingId=this.bookingId;
      let payload={"action":'clickedReview',"payload":review}
      console.log(1259,payload)
      let w= await this.updateDB(payload)
      console.log(992,w,w.errorid);
    }, 
    async saveReview()
    {
      this.loading=true;
      var token=Date.now();
      navigator.clipboard.writeText(this.review.review+'\ntoken:' + token);
      this.hostname=window.location.hostname;
      console.log(437,this.hostname);
      
      this.QRCodeLink='https://'+this.hostname+'/qrcodevalidate/?p='+this.bookingId
      var rrr='review';
      const { [rrr]:_, ...fb } = this.review;
      this.totalScore= Object.values(fb).reduce((a, b) => a/1 + (isNaN(b)?0:b)/1, 0);
      console.log(389,this.totalScore)
      var review= {... this.review}
      review.bookingId=this.bookingId;
      review.token=token;
      review.qrcode=this.QRCodeLink;
      review.totalScore=parseInt(this.totalScore);
      let payload={"action":'saveReview',"payload":review}
      console.log(1259,payload)
      let w= await this.updateDB(payload)
      console.log(992,w,w.errorid);
      this.loading=false;
      console.log(1075,w)
      switch (w.errorid)
      {
        case '0':      
          console.log(1078,w)
          this.payloads=w.payloads;
          if (this.partialScore>=parseInt(this.settings.options.reviewThresholdTripAdvisor))
          this.dialog_leave_to_tripadvisor=true
          else this.dialog_thanks=1    
          this.reviewSaved=true;
        break;
        case '0001':
          /*
          this.snackbar.color='error'
          this.snackbar.text=w.message
          this.snackbar.active=1;
          */
          this.dialog_duplicated=true;
        break;
      }
    },
    async updateDB(payload){
      try{
          const res = await this.$http.post('/review/review.php', payload);
          console.log(1284,res);
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
          }
          else
          {
            console.log(1291);
            //this.$router.push('/auth/login').catch(() => {});
          }
          return res.data;
      } catch(e)
      {
        this.dialog_connection_error=true;
        console.log(e);
      }
    },
  },
};
</script>
